import React from 'react';
import Dialog from '@mui/material/Dialog';

import type { ISnippet } from 'src/services/api';
import SnippetForm from 'src/pages/landlord/snippets/components/form';

type InitialValues = {
    name?: string;
    contents?: string;
    is_private?: boolean;
};

type Props = {
    onClose: () => void;
    snippet?: ISnippet;
    initialValues?: InitialValues;
}

export default function CreateOrUpdateSnippetModal({
    onClose,
    snippet,
    initialValues,
}: Props) {
    return (
        <Dialog
            open
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: '100%',
                    minHeight: '450px',
                }
            }}
        >
            <SnippetForm snippet={snippet} initialValues={initialValues} onClose={onClose} />
        </Dialog>
    );
}